import React from 'react'

import ImportRequestsTable from './ExportAndAccessRequestsTable/ImportRequestsTable'

export const ImportRequestsTab = () => {
  return <ImportRequestsTable />
}
